export const CATEGORIES = [
  { slug: "national", name_hi: "राष्ट्रीय", name_en: "National" },
  { slug: "international", name_hi: "अंतरराष्ट्रीय", name_en: "International" },
  { slug: "politics", name_hi: "राजनीति", name_en: "Politics" },
  { slug: "business", name_hi: "बिजनेस", name_en: "Business" },
  { slug: "entertainment", name_hi: "मनोरंजन", name_en: "Entertainment" },
  { slug: "sports", name_hi: "खेल", name_en: "Sports" },
  { slug: "lifestyle", name_hi: "लाइफस्टाइल", name_en: "Lifestyle" },
  { slug: "technology", name_hi: "टेक्नोलॉजी", name_en: "Technology" },
  { slug: "spirituality", name_hi: "धर्म एवं अध्यात्म", name_en: "Spirituality" },
  { slug: "astrology", name_hi: "ज्योतिष", name_en: "Astrology" },
  { slug: "health", name_hi: "हेल्थ", name_en: "Health" },
  { slug: "education", name_hi: "शिक्षा", name_en: "Education" },
  { slug: "viral", name_hi: "वायरल", name_en: "Viral" },
  { slug: "podcast", name_hi: "पॉडकास्ट", name_en: "Podcast" },
  { slug: "video", name_hi: "वीडियो", name_en: "Video News" },
];

export const getCategory = (slug) =>
  CATEGORIES.find((c) => c.slug === slug) || { slug, name_hi: slug, name_en: slug };
